import React, {memo} from "react"
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import FormSection from "../../../components/FormSection";

import Model1Select from "./Model1Select";
import Model1MeasureField from "./Model1MeasureField";
import {formikPropertyEqual} from "./index";


export const snowDataColumns = ['ps', 'th10', 'th30', 'pr', 'pf', 'sf', 'sh'];


const SnowData = memo(({formik, model1Registry, warnings, inputDisabled, visibleColumns}) => {
    const {t} = useTranslation(['models1']);

    const pfRegistry = model1Registry.data?.pf ?? [];
    const sfRegistry = model1Registry.data?.sf ?? [];
    const shRegistry = model1Registry.data?.sh ?? [];

    const isVisible = (column) => (!visibleColumns || visibleColumns?.[column]);

    return <FormSection title={t('model1Form.snowData')}>
        <Grid container rowSpacing={3} columnSpacing={4}>
            {
                isVisible("ps") &&
                <>
                    <Grid item xs={12} md={6}>
                        <Model1MeasureField name="ps" formik={formik} unitOfMeasure="kg/m3" warnings={warnings}
                                            disabled={inputDisabled} type="number"/>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{display: {xs: "none", md: "block"}}}/>
                </>
            }
            {
                isVisible("th10") &&
                <Grid item xs={12} md={6}>
                    <Model1MeasureField name="th10" formik={formik} unitOfMeasure="°C" warnings={warnings}
                                        disabled={inputDisabled} type="number"/>
                </Grid>
            }
            {
                isVisible("th30") &&
                <Grid item xs={12} md={6}>
                    <Model1MeasureField name="th30" formik={formik} unitOfMeasure="°C" warnings={warnings}
                                        disabled={inputDisabled} type="number"/>
                </Grid>
            }
            {
                isVisible("pr") &&
                <>
                    <Grid item xs={12} md={6} >
                        <Model1MeasureField name="pr" formik={formik} unitOfMeasure="cm" warnings={warnings}
                                            disabled={inputDisabled} type="number"/>
                    </Grid>
                    <Grid item xs={12} sx={{display: {xs: "none", md: "block"}}}/>
                </>
            }
            {
                isVisible("pf") &&
                <>
                    <Grid item xs={12} md={6}>
                        <Model1Select name="pf" formik={formik} registry={pfRegistry} warnings={warnings}
                                      disabled={inputDisabled}/>
                    </Grid>
                    <Grid item sx={{display: {xs: "none", md: "block"}}}/>
                </>
            }
            {
                isVisible("sf") &&
                <>
                    <Grid item xs={12} md={6}>
                        <Model1Select name="sf" formik={formik} registry={sfRegistry} warnings={warnings}
                                      disabled={inputDisabled}/>
                    </Grid>
                    <Grid item sx={{display: {xs: "none", md: "block"}}}/>
                </>
            }
            {
                isVisible("sh") &&
                <>
                    <Grid item xs={12} md={6}>
                        <Model1Select name="sh" formik={formik} registry={shRegistry} warnings={warnings}
                                      disabled={inputDisabled}/>
                    </Grid>
                    <Grid item sx={{display: {xs: "none", md: "block"}}}/>
                </>
            }
        </Grid>
    </FormSection>
}, (prevProps, nextProps) => formikPropertyEqual(prevProps, nextProps, snowDataColumns));

export default SnowData;